import $ from "jquery";

$(() => {
    try {
        Homerun.lang = "nl";
        Homerun.loadWidget("okdzg8yc5ghpgmov7cl2");
    } catch (e) {
        // This could be thrown to Sentry
        throw e;
    }
});
